/* eslint-disable default-case, no-fallthrough */
export const WEIGHTS = {
  KILOTONNE: 'KILOTONNE',
  TONNE: 'TONNE',
  KILOGRAMM: 'KILOGRAMM',
  GRAMM: 'GRAMM'
};
const dict = {
  KILOTONNE: ['KT'],
  TONNE: ['TO', 'T', 'TNW', 'TDR', 'TN', 'Т'],
  KILOGRAMM: ['KG', 'КГ'],
  GRAMM: ['G', 'Г']
};

export const getUnit = (value) => {
  if (typeof value !== 'string') return '';

  const val = value.toUpperCase();
  // eslint-disable-next-line no-restricted-syntax
  for (const unit in dict) {
    if (dict[unit].includes(val)) {
      return unit;
    }
  }
  return '';
};

/** Доработка предыдущей функции, getUnit
 * @param unit <'T', 'KG', 'G', ''> вес из справочника
 * return <boolean> весовая единица, если из справочника и нет если ''
 */
export const isWeightUnit = (unit) => !!getUnit(unit);

/** Килограмм в тонну и обратно
 * @param weight <number> вес
 * @param reverse <boolean> обратная конвертация
 */
const kiloToTonne = (weight, reverse = false) => {
  if (reverse) {
    return weight * 1000;
  }
  return weight / 1000;
};

/** Килограмм в грамм и обратно
 * @param weight <number> вес
 * @param reverse <boolean> обратная конвертация
 */
const kiloToGramm = (weight, reverse = false) => {
  if (reverse) {
    return weight / 1000;
  }
  return weight * 1000;
};

/** Тонны в граммы и обратно
 * @param weight <number> вес
 * @param reverse <boolean> обратная конвертация
 */
const tonneToGramm = (weight, reverse = false) => {
  if (reverse) {
    return weight / 1000 ** 2;
  }
  return weight * 1000 ** 2;
};

/** Конвертирует весовые значения T, KG, G из текущего в целевой
 * @param weight <number> вес
 * @param currentUnit <'T', 'KG', 'G'> текущая ЕИ
 * @param targetUnit <'T', 'KG', 'G'> целевая ЕИ
 */

export default function convertWeightUnit(weight, currentUnit, targetUnit) {
  const curr = getUnit(currentUnit);
  const target = getUnit(targetUnit);

  if (!curr || !target || curr === target || weight === 0) return weight;
  switch (curr) {
    case WEIGHTS.TONNE:
      switch (target) {
        case WEIGHTS.KILOGRAMM:
          return kiloToTonne(weight, true);
        case WEIGHTS.GRAMM:
          return tonneToGramm(weight);
        default:
          return weight;
      }
    case WEIGHTS.KILOGRAMM:
      switch (target) {
        case WEIGHTS.TONNE:
          return kiloToTonne(weight);
        case WEIGHTS.GRAMM:
          return kiloToGramm(weight);
        default:
          return weight;
      }
    case WEIGHTS.GRAMM:
      switch (target) {
        case WEIGHTS.TONNE:
          return tonneToGramm(weight, true);
        case WEIGHTS.KILOGRAMM:
          return kiloToGramm(weight, true);
        default:
          return weight;
      }
    default:
      return weight;
  }
}
